module.exports = "/dist/assets/images/close.svg";